import { StoryblokServerComponent, storyblokEditable } from '@storyblok/react/rsc'
import Frame from '@/components/storyblok/global/Frame'

const Page = async ({ blok, rels }) => {
  return (
    <div {...storyblokEditable(blok)}>
      <Frame blok={blok?.frame?.content} rels={rels}>
        {blok?.body?.map((currentSection, index) => {
          return (
            <StoryblokServerComponent
              key={currentSection?._uid}
              blok={currentSection}
              rels={rels}
              headingLevel={index === 0 ? 1 : 2}
              imagePriority={index === 0 || index === 1}
              // * Specific to Press/Post. Wanted to add for consistency
              padding={undefined}
              lowerHeadingStyles={undefined}
            />
          )
        })}
      </Frame>
    </div>
  )
}

export default Page
